import React, { useEffect, useState } from 'react';
import cyanSvg from "../../../../../assets/images/cyanInkDrop.svg";
import magentaSvg from "../../../../../assets/images/magentaInkDrop.svg";
import yellowSvg from "../../../../../assets/images/yellowInkDrop.svg";
import blackSvg from "../../../../../assets/images/blackInkDrop.svg";
import allSvg from "../../../../../assets/images/allInkDrop.svg";
import { useDispatch, useSelector } from 'react-redux';
import './EasyBuy.css';
import { routePath } from '../../../../../constants/Routes';
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { Upgrade_To_Ecopro_Status } from '../../../../../actions/Dashboard';
import { EnrollmentRegisterServiceReset } from '../../../../../store/brotherPlus/EnrollmentService/RegisterService/RegisterServiceSlice';
import { FetchUserAccount } from '../../../../../actions/UserAccount';
import { LOCALSESSIONDATAKEYS, UPGRADE_TO_ECOPRO } from '../../../../../constants/AppConstants';
import { getLocalSessionData } from '../../../../../utils/Authentication/handleUserSession';
import rightArrowBlue from "../../../../../assets/images/rightArrowBlue.svg";
import EasyBuyOptionsDesktopView from './EasyBuyOptionsDesktopView';
import EasyBuyOptionsMobileView from './EasyBuyOptionsMobileView';

export const EasyBuyContext = React.createContext({});

const colorToImage = {
  Cyan: cyanSvg,
  Magenta: magentaSvg,
  Yellow: yellowSvg,
  Black: blackSvg,
  'Value Pack': allSvg,
  All: allSvg
};

const colours = {
  Cyan: "#A0F9FF",
  Magenta: "#F05FEF",
  Yellow: "#F5F44E",
  Black: "black",
  All: "all"
}

const EasyBuy = ({ isApplyBPlusNewDeviceDiscount = false, setEasyBuySummaryData, easyBuySummaryData, lowInkList, lowInkReplaced }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { easyBuyData } = useSelector(
    (state) => state.ROOTREDUCER_RTK.EasyBuy
  );

  const [inkDetails, setInkDetails] = useState([]);
  const [selectedCapacities, setSelectedCapacities] = useState({});

  useEffect(() => {
    if (!easyBuyData?.supplyItems?.length) return;

    const grouped = Object.values(
      easyBuyData.supplyItems.reduce((acc, item) => {
        const color = item.supplyItemColor === "Value Pack" ? "All" : item.supplyItemColor;
        if (!acc[color]) {

          acc[color] = {
            name: color,
            img: colorToImage[color] || allSvg,
            capacityOptions: [],
            variants: [],
            colours: colours[color]
          };
        }

        const label = item.supplyItemCode.includes('XL') ? 'XL' : `${t("EASY_BUY.STANDARD")}`;
        const optionLabel = `${label} (${item.supplyItemPages} ${t("EASY_BUY_SUMMARY.PAGES")})`;

        acc[color].capacityOptions.push(optionLabel);
        acc[color].variants.push({
          pages: item.supplyItemPages,
          price: item.priceWithoutTax,
          discountedPrice: item.priceAfterDiscount,
          priceWithoutTax:item.priceWithoutTax,
          currency: item.currency,
          label: label,
          supplyItemCode: item.supplyItemCode
        });

        return acc;
      }, {})
    );

    setInkDetails(grouped);

    const defaults = {};
    grouped.forEach((color) => {
      defaults[color.name] = color.capacityOptions[0];
    });
    setSelectedCapacities(defaults);
    // eslint-disable-next-line
  }, [easyBuyData]);

  useEffect(() => {
    if (inkDetails.length && lowInkList?.length) {
      inkDetails?.forEach(color => {
        if (lowInkList?.indexOf(color.name) !== -1) {
          const variant = getPrice(color);
          setEasyBuySummaryData(prevData => {
            if (!prevData?.find(item => item.name === color.name)) {
              return [
                ...prevData,
                {
                  ...color,
                  discountedPrice: variant.discountedPrice,
                  details: variant.pages,
                  price: variant.price,
                  currency: variant.currency,
                  label: variant.label,
                  supplyItemCode: variant.supplyItemCode,
                  priceWithoutTax:variant.priceWithoutTax
                }
              ];
            }
            
            // diaply new device discount price when promotion banner is clicked
            return isApplyBPlusNewDeviceDiscount
              ? prevData?.map(item => (item.name === color.name && item.discountedPrice !== variant?.discountedPrice)
                ? { ...item, discountedPrice: variant.discountedPrice }
                : item
              )
              : prevData;
          });
        }
      })
    }
    if (lowInkReplaced?.length) {
      inkDetails?.forEach(color => {
        if (lowInkReplaced?.indexOf(color.name) !== -1) {
          setEasyBuySummaryData(prevData => {
            return prevData?.filter(prevDatum => prevDatum.name !== color.name)
          });
        }
      })
    }
    // eslint-disable-next-line
  }, [lowInkList, inkDetails, lowInkReplaced]);

  const handleExplorePlans = () => {
    const UID = getLocalSessionData(LOCALSESSIONDATAKEYS.UID);
    const AZURE_AD_B2C_UID = getLocalSessionData(LOCALSESSIONDATAKEYS.AZURE_AD_B2C_UID);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    dispatch(Upgrade_To_Ecopro_Status(true));
    dispatch(EnrollmentRegisterServiceReset());
    dispatch(FetchUserAccount(AZURE_AD_B2C_UID, UID, deviceId, UPGRADE_TO_ECOPRO));
    history.push({ pathname: routePath.ROLE_REDIRECTION, state: { 'upgradeTo_EcoProProcess': true } });
  }

  const handleCapacityChange = (colorName, value) => {
    setSelectedCapacities((prev) => ({
      ...prev,
      [colorName]: value
    }));
  };

  const getPrice = (color) => {
    const selected = selectedCapacities[color.name];
    const pages = parseInt(selected.match(/\((\d+)/)[1]);
    const variant = color.variants.find((v) => v.pages === pages);
    return variant || color.variants[0];
  };

  const values = {
    inkDetails: inkDetails,
    easyBuySummaryData: easyBuySummaryData,
    getPrice: getPrice,
    selectedCapacities: selectedCapacities,
    handleCapacityChange: handleCapacityChange,
    setEasyBuySummaryData: setEasyBuySummaryData
  };

  return (
    <div className="easyBuyContainer">
      <EasyBuyContext.Provider value={values}>
        <EasyBuyOptionsDesktopView> </EasyBuyOptionsDesktopView>
        <EasyBuyOptionsMobileView ></EasyBuyOptionsMobileView>
      </EasyBuyContext.Provider>
      <div className="easy-buy-ecopro-banner">
        <div className="easy-buy-ecopro-left">
          <div ><circleSvg /></div>
          <span className='Upgrade-text'>
            {t("EASY_BUY.ECOPRO_BANNER.SAVE_TEXT")} <strong>{t("EASY_BUY.ECOPRO_BANNER.ECOPRO_BOLD")}</strong>
          </span>
        </div>
        <div className="easy-buy-ecopro-right">
          <button className="easy-buy-ecopro-link" onClick={handleExplorePlans}>{t("EASY_BUY.ECOPRO_BANNER.EXPLORE_PLANS")}<img src={rightArrowBlue} alt="right arrow" /> </button>
        </div>
      </div>

    </div>
  );
};

export default EasyBuy;
